class C1868Category {
  constructor (data) {
    this.id = data ? data.id : ''
    this.name = data ? data.name : ''
    // eslint-disable-next-line eqeqeq
    this.is_enabled = data ? (data.is_enabled == 1) : false
    // eslint-disable-next-line eqeqeq
    this.sort_no = data ? data.sort_no : null
    this.thumbnail = data ? data.thumbnail : null
    this.thumbnailUrl = data ? data.thumbnailUrl : null
  }

  getFormData () {
    let formData = new FormData()
    formData.append('id', this.id)
    formData.append('name', this.name)
    formData.append('is_enabled', this.is_enabled)
    formData.append('sort_no', this.sort_no)
    formData.append('thumbnail', this.thumbnail)
    return formData
  }
}

export default C1868Category



// WEBPACK FOOTER //
// ./src/models/C1868Category.js